<template>
  <v-card
    class="mx-auto my-12"
    max-width="374"
  >

    <v-img
        height="250"
        :src="image"
    ></v-img>

    <v-card-title>{{ title }}</v-card-title>

    <v-divider class="mx-4"></v-divider>

    <v-row>
        <v-col col="6"> <!-- TODO:  Font Awesome icons to add some spice here -->
            <v-card-title style="justify-content: center;">Address</v-card-title>
        </v-col>

        <v-col col="6">
            <v-card-title style="justify-content: center;">Phone</v-card-title>
        </v-col>
    </v-row>

    <v-card-text>
        <v-row justify="space-around">
            <v-col col="6" align="center">
                <address class="pa-0 ma-0">
                    <p>{{ addressLine1 }}</p>
                    <p>{{ addressLine2 }}</p>
                </address>
            </v-col>

            <v-col col="6" align="center">
                <a :href="'tel:' + phoneNumber">{{ phoneNumber }}</a>
            </v-col>
        </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: 'ContactCard',
    props: {
        /**
         * The title of the card
         */
        title: String,
        /**
         * The subtitle of the card
         */
        subtitle: String,
        /**
         * The image path to use for the card.
         */
        image: String,
        /**
         * Decides whether or not the image will have the
         * image-size: contain; css property or not.
         */
        contained: Boolean,
        /**
         * First line of the address associated with the
         * card.
         */
        addressLine1: String,
        /**
         * Second line of the address associated with the
         * card.
         */
        addressLine2: String,
        /**
         * The phone number associated with the card.
         */
        phoneNumber: String
    }
}
</script>